module.exports = __webpack_public_path__ + "static/media/police-box.f4915935.svg";